const menu = document.querySelector(".menu");
const menuMain = menu.querySelector(".menu-main");
const goBack = menu.querySelector(".go-back");
const menuTrigger = document.querySelector(".mobile-menu-trigger");
const closeMenu = menu.querySelector(".mobile-menu-close");
const overlay = document.querySelector(".menu-overlay");
let subMenu;
let currentMenuLevel = 0;
let currentSubMenu = [];

menuMain.addEventListener("click", (e) => {
    if (!menu.classList.contains("active")) return;

    const hasChildren = e.target.closest(".menu-item-has-children");

    // Vérifie si le clic est sur l'icône flèche
    if (e.target.classList.contains("fa-angle-down") && hasChildren) {
        e.preventDefault(); // Empêche la redirection
        showSubMenu(hasChildren);
    }
});

goBack.addEventListener("click", () => {
    hideSubMenu();
});

menuTrigger.addEventListener("click", () => {
    toggleMenu();
});

closeMenu.addEventListener("click", () => {
    toggleMenu();
});

overlay.addEventListener("click", () => {
    toggleMenu();
});

function toggleMenu() {
    menu.classList.toggle("active");
    overlay.classList.toggle("active");
}

function showSubMenu(hasChildren) {
    subMenu = hasChildren.querySelector(".sub-menu");
    subMenu.classList.add("active");
    subMenu.style.animation = "slideLeft 0.5s ease forwards";
    
    const menuTitle = hasChildren.querySelector("a").textContent.trim();
    menu.querySelector(".current-menu-title").innerHTML = menuTitle;

    menu.querySelector(".mobile-menu-head").classList.add("active");
    
    currentMenuLevel++;
    currentSubMenu.push(subMenu);

    goBack.style.display = "block";
}

function hideSubMenu() {
    if (currentMenuLevel > 1) {
        const lastSubMenu = currentSubMenu.pop();
        lastSubMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
            lastSubMenu.classList.remove("active");
        }, 300);

        const previousSubMenu = currentSubMenu[currentSubMenu.length - 1];
        const previousTitle = previousSubMenu ? previousSubMenu.parentNode.querySelector("a").textContent.trim() : "";
        menu.querySelector(".current-menu-title").innerHTML = previousTitle;
    } else {
        subMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
            subMenu.classList.remove("active");
        }, 300);
        menu.querySelector(".current-menu-title").innerHTML = "";
    }

    currentMenuLevel--;

    if (currentMenuLevel === 0) {
        goBack.style.display = "none";
    }
    
    menu.querySelector(".mobile-menu-head").classList.toggle("active", currentMenuLevel > 0);
}

window.onresize = function () {
    if (this.innerWidth > 991) {
        if (menu.classList.contains("active")) {
            toggleMenu();
        }
    }
};

const scrollBtn = document.querySelector('.scroll-btn');
if (scrollBtn) {
    scrollBtn.addEventListener('click', function () {
        // Sélectionne la section avec la classe .home-news
        const homeNewsSection = document.querySelector('.home-news');
        
        if (homeNewsSection) {
            // Défile jusqu'à la section .home-news
            homeNewsSection.scrollIntoView({
                behavior: 'smooth', // Défilement fluide
                block: 'start'     // Alignement en haut
            });
        } else {
            console.warn('La section .home-news n’existe pas sur cette page.');
        }
    });
} else {
    console.warn('Le bouton .scroll-btn n’existe pas sur cette page.');
}


if (document.querySelectorAll('#offcanvasScrolling').length > 0) {

    var OffcanvasFilter = document.getElementById('offcanvasScrolling')
    OffcanvasFilter.addEventListener('show.bs.offcanvas', function () {
        window.scrollTo(0, 0);

    })
}

//mega menu

const level1LiMega = document.querySelectorAll('.level1Li-mega');
const level1ChevronClick = document.querySelectorAll('.level1ChevronClick');
const level2LiMega = document.querySelectorAll('.level2Li-mega');
const level3LiMega = document.querySelectorAll('.level3Li-mega');

// Hide level two and level three by default
level2LiMega.forEach(item => {
    item.style.display = 'none';

    item.addEventListener('click', e => {
        level2LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            item.style.color = '#33424B'

        });
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const id = item.getAttribute('data-id-level');
        level3LiMega.forEach(element => {
            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionTwo = element.getAttribute('data-sectionTwo');
                // console.log(sectionTwo)
                const titleLvlThree = document.querySelector('#titleLvlThree');
                titleLvlThree.textContent = sectionTwo;
            } else {
                element.style.display = 'none';

            }
        });
    });

});

level3LiMega.forEach(item => {
    item.style.display = 'none';
});

level1LiMega.forEach(item => {
    //accesibility
    const navElements = document.querySelectorAll('.level1ChevronClick');

    item.addEventListener('keydown', e => {

        if (navElements && e.keyCode === 13) {
            // console.log("click")
            navElements.forEach(NavElement => {
                NavElement.tabIndex = -1;

            })
        }

        level1LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            const titleLvlThree = document.querySelector('#titleLvlThree');
            titleLvlThree.textContent = ''
            // const loopIndex = item.getAttribute('data-loopIndex');


        });
        const id = item.getAttribute('data-id');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const noLink = item.getAttribute('data-nolink');

        const sectionOneLink = item.getAttribute('data-link');


        level2LiMega.forEach(element => {

            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionOne = element.getAttribute('data-section');
                const titleLvlTwo = document.querySelector('#titleLvlTwo');
                const linkLvlTwo = document.querySelector('#linkLvlTwo');
                // console.log('link :' + sectionOneLink)
                titleLvlTwo.textContent = sectionOne;
                linkLvlTwo.title = sectionOne;

                if (sectionOneLink) {
                    linkLvlTwo.href = sectionOneLink;
                    // console.log(sectionOneLink)

                } else {
                    linkLvlTwo.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';
            }
        });
        level3LiMega.forEach(item => {
            item.style.display = 'none';
        });

    })

    item.addEventListener('click', e => {


        level1LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            const titleLvlThree = document.querySelector('#titleLvlThree');
            titleLvlThree.textContent = ''
            // const loopIndex = item.getAttribute('data-loopIndex');


        });
        const id = item.getAttribute('data-id');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const noLink = item.getAttribute('data-nolink');

        const sectionOneLink = item.getAttribute('data-link');


        level2LiMega.forEach(element => {

            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionOne = element.getAttribute('data-section');
                const titleLvlTwo = document.querySelector('#titleLvlTwo');
                const linkLvlTwo = document.querySelector('#linkLvlTwo');
                // console.log('link :' + sectionOneLink)
                titleLvlTwo.textContent = sectionOne;
                linkLvlTwo.title = sectionOne;

                if (sectionOneLink) {
                    linkLvlTwo.href = sectionOneLink;
                    // console.log(sectionOneLink)

                } else {
                    linkLvlTwo.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';
            }
        });
        level3LiMega.forEach(item => {
            item.style.display = 'none';
        });
    });

})
;

level2LiMega.forEach(item => {
    item.style.display = 'none';

    item.addEventListener('click', e => {
        level2LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            item.style.color = '#33424B'

        });
        const sectionTwoLink = item.getAttribute('data-link');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const id = item.getAttribute('data-id-level');
        level3LiMega.forEach(element => {
            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionTwo = element.getAttribute('data-sectionTwo');
                const titleLvlThree = document.querySelector('#titleLvlThree');
                titleLvlThree.textContent = sectionTwo;
                const linkLvlThree = document.querySelector('#linkLvlThree');
                linkLvlThree.href = sectionTwoLink;
                linkLvlThree.title = sectionTwo;

                if (sectionTwoLink) {
                    linkLvlThree.href = sectionTwoLink;

                } else {
                    linkLvlThree.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';

            }
        });
    });

});

level3LiMega.forEach(item => {
    item.style.display = 'none';
});